import { postJSON } from 'common/services/api'
import {
  REVISIONS_QUERY_KEY,
  REVISION_ROLLBACK_URL,
  REVISION_ROLLBACK_QUERY_KEY,
  REVISION_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'

type UseRevisionRollbackReturn = {
  rollbackRevision?: () => Promise<unknown>
  isRollbackRevisionLoading?: boolean
}

type UseRevisionRollbackProps = {
  id?: string
}

const useRevisionRollback = ({
  id,
}: UseRevisionRollbackProps): UseRevisionRollbackReturn => {
  const queryClient = useQueryClient()

  // Rollback event
  const rollbackFunction = async (): Promise<unknown> => {
    return postJSON({
      url: `${REVISION_ROLLBACK_URL}/${id}`,
      method: 'PUT',
      isRota: true,
    })
  }

  const {
    mutateAsync: rollbackMutation,
    isLoading: isRollbackRevisionLoading,
  } = useMutation<unknown>([REVISION_ROLLBACK_QUERY_KEY], rollbackFunction, {
    onSuccess: () => {
      queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
      queryClient.invalidateQueries([REVISION_QUERY_KEY, id])
    },
  })

  const handleRollback = async () => {
    try {
      const result = await rollbackMutation()
      return result
    } catch (err) {
      return err
    }
  }

  return {
    rollbackRevision: handleRollback,
    isRollbackRevisionLoading,
  }
}

export default useRevisionRollback
